import { DecisionDetailStatusCode } from '@/components/pages/Applicant/Applicant.types';
import {
    ConditionDefinitionProduct,
    ConditionDefinitionTrigger,
    ConditionTriggerQualifier,
} from '@/components/shared/api/endpoints/conditionDefinitions';

// Shown wherever a template has no trigger; the stored value is still "Manual" (no row).
export const MANUAL_TRIGGER_LABEL = 'No Trigger';
const TRIGGER_SEPARATOR = ' · ';

export const PRODUCT_LABEL: Record<ConditionDefinitionProduct, string> = {
    [ConditionDefinitionProduct.Unknown]: 'Unknown',
    [ConditionDefinitionProduct.Factoring]: 'Factoring',
    [ConditionDefinitionProduct.LoadPay]: 'LoadPay',
    [ConditionDefinitionProduct.TcsFuel]: 'TCS Fuel Card',
};

export const STATUS_LABEL: Record<DecisionDetailStatusCode, string> = {
    [DecisionDetailStatusCode.Unknown]: 'Unknown',
    [DecisionDetailStatusCode.Invited]: 'Invited',
    [DecisionDetailStatusCode.Landed]: 'Landed',
    [DecisionDetailStatusCode.Started]: 'Started',
    [DecisionDetailStatusCode.Finished]: 'Finished',
    [DecisionDetailStatusCode.Created]: 'Created',
    [DecisionDetailStatusCode.Submitted]: 'Submitted',
    [DecisionDetailStatusCode.UnderReview_Auto]: 'Under Automated Review',
    [DecisionDetailStatusCode.UnderReview_Manual]: 'Under Manual Review',
    [DecisionDetailStatusCode.NeedMoreInfo]: 'Needs More Info',
    [DecisionDetailStatusCode.Approved]: 'Approved',
    [DecisionDetailStatusCode.Denied]: 'Denied',
    [DecisionDetailStatusCode.Abandoned]: 'Abandoned',
    [DecisionDetailStatusCode.ContractSent]: 'Contract Sent',
    [DecisionDetailStatusCode.ContractSigned]: 'Contract Signed',
    [DecisionDetailStatusCode.DeltaClientCreated]: 'Delta Client Created',
    [DecisionDetailStatusCode.Onboarded]: 'Onboarded',
    [DecisionDetailStatusCode.InvoiceFactored]: 'Invoice Factored',
    [DecisionDetailStatusCode.Errored]: 'Errored',
};

const QUALIFIER_LABEL: Record<ConditionTriggerQualifier, string | null> = {
    [ConditionTriggerQualifier.Unknown]: null,
    [ConditionTriggerQualifier.CarrierOnly]: 'Carrier only',
    [ConditionTriggerQualifier.DriverOnly]: 'Driver only',
    [ConditionTriggerQualifier.PerOwner]: 'per owner',
};

const formatTrigger = ({ product, status, qualifier }: ConditionDefinitionTrigger): string => {
    const statusLabel = STATUS_LABEL[status] ?? DecisionDetailStatusCode[status];
    const productStatus = `${PRODUCT_LABEL[product]}: ${statusLabel}`;
    const qualifierLabel = qualifier == null ? null : QUALIFIER_LABEL[qualifier];
    return qualifierLabel ? `${productStatus}${TRIGGER_SEPARATOR}${qualifierLabel}` : productStatus;
};

export const formatConditionTriggers = (triggers: ConditionDefinitionTrigger[]): string =>
    triggers.length === 0
        ? MANUAL_TRIGGER_LABEL
        : triggers.map(formatTrigger).join(TRIGGER_SEPARATOR);
